<template>
  <header v-if="$store.getters['user/isNavVisible']" class="bg-white shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <router-link to="/" class="text-xl font-bold text-blue-600 flex items-center">
              <img src="@/assets/logo.png" alt="喵记" class="h-6 w-6 mr-2">
              喵记
            </router-link>
          </div>
          
          <nav v-if="!isAuthPage" class="hidden md:ml-6 md:flex md:space-x-8">
            <router-link 
              to="/" 
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path === '/' 
                  ? 'border-blue-500 text-gray-900' 
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]"
            >
              首页
            </router-link>
            
            <router-link 
              to="/notes" 
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path.startsWith('/notes') 
                  ? 'border-blue-500 text-gray-900' 
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]"
            >
              笔记
            </router-link>

            <router-link
              to="/anki-library"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path.startsWith('/anki-library')
                 ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]" 
            >
              Anki资源库
            </router-link>

            <router-link
              to="/word-book"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path.startsWith('/word-book')
                 ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]" 
            >
              单词表
            </router-link>
            
            <router-link 
              to="/review-plan" 
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path === '/review-plan' 
                  ? 'border-blue-500 text-gray-900' 
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]"
            >
              复习计划
            </router-link>

            <!-- 插件下载 -->
            <router-link
              to="/help"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path.startsWith('/help')
                ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]"
            >
              插件下载
            </router-link>

            <!-- 帮助 -->
            <router-link
              to="/help"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              :class="[
                $route.path.startsWith('/help')
                ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              ]"
            >
              帮助
            </router-link>
          </nav>
        </div>
        
        <div v-if="!isAuthPage" class="flex items-center">
          <router-link 
            to="/profile" 
            class="p-2 rounded-full text-gray-500 hover:text-gray-700 hover:bg-gray-100"
            :class="{ 'bg-gray-100': $route.path === '/profile' }"
          >
            <i class="fas fa-user"></i>
          </router-link>
          <template v-if="$store.getters['user/isAuthenticated']">
            <div class="flex items-center">
              
              <span class="mr-4 text-gray-700">
                你好，{{ $store.getters['user/currentUser']?.user_name }}
              </span>
              <img 
                :src="$store.getters['user/currentUser']?.user_avatar || '/assets/logo.png'" 
                :alt="$store.getters['user/currentUser']?.user_name"
                class="w-8 h-8 rounded-full mr-2"
              />
              <button
                @click="logout"
                class="btn-secondary px-4 py-2"
              >
                <i class="fas fa-sign-out-alt mr-2"></i>
                退出登录
              </button>
            </div>
          </template>
          <template v-else>
            <router-link 
              to="/login"
              class="btn-primary px-4 py-2"
            >
              <i class="fas fa-sign-in-alt mr-2"></i>
              登录/注册
            </router-link>
          </template>
        </div>
      </div>
    </div>
    
    <!-- 移动端导航 -->
    <div v-if="!isAuthPage" class="md:hidden border-t">
      <div class="grid grid-cols-5 text-xs">
        <router-link 
          to="/" 
          class="flex flex-col items-center py-2"
          :class="$route.path === '/' ? 'text-blue-600' : 'text-gray-500'"
        >
          <i class="fas fa-home text-lg mb-1"></i>
          <span>首页</span>
        </router-link>
        
        <router-link 
          to="/anki-library" 
          class="flex flex-col items-center py-2"
          :class="$route.path.startsWith('/anki-library') ? 'text-blue-600' : 'text-gray-500'"
        >
          <i class="fas fa-layer-group text-lg mb-1"></i>
          <span>资源库</span>
        </router-link>

        <router-link 
          to="/word-book" 
          class="flex flex-col items-center py-2"
          :class="$route.path.startsWith('/word-book') ? 'text-blue-600' : 'text-gray-500'"
        >
          <i class="fas fa-book text-lg mb-1"></i>
          <span>单词</span>
        </router-link>
        
        <router-link 
          to="/review-plan" 
          class="flex flex-col items-center py-2"
          :class="$route.path === '/review-plan' ? 'text-blue-600' : 'text-gray-500'"
        >
          <i class="fas fa-calendar-alt text-lg mb-1"></i>
          <span>计划</span>
        </router-link>
        
        <router-link 
          to="/profile" 
          class="flex flex-col items-center py-2"
          :class="$route.path === '/profile' ? 'text-blue-600' : 'text-gray-500'"
        >
          <i class="fas fa-user text-lg mb-1"></i>
          <span>我的</span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'AppHeader',
  setup() {
    const store = useStore()
    const router = useRouter()

    const logout = async () => {
      await store.dispatch('user/logout')
      router.push('/login')
    }

    const isAuthPage = computed(() => {
      return ['login', 'register'].includes(router.currentRoute.value.name)
    })

    return { logout, isAuthPage }
  }
}
</script>